import type {
  DestinationAvailabilityCriteria,
  GraphQL,
} from '@libs/trip-planner-interfaces';
import { normalizeDateOnlyString } from '@libs/utils';

import { getRecipeQL } from './recipeQL';

export function getCheapestStayByHotelRequestQL(
  criteria: DestinationAvailabilityCriteria
): GraphQL.CheapestStayByHotelRequestQL {
  return {
    recipe: getRecipeQL({
      userCriteria: criteria.userCriteria.recipe,
      businessCriteria: criteria.businessCriteria,
    }),
    ingredientIndex: criteria.userCriteria.ingredientIndex,
    constraint: criteria.userCriteria.constraint,
    day: normalizeDateOnlyString(criteria.userCriteria.day),
  };
}
